import { useMutation } from '@tanstack/react-query';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { AxiosResponse } from 'axios';
import {
  configureIntegrationV2,
  ConfigureIntegrationV2Payload,
  ConfigureIntegrationV2ErrorResponse,
  ConfigureIntegrationV2SuccessResponse,
} from 'IntegrationModule/api/configureIntegrationV2Api';
import { selectAuthToken } from 'selectors';
import { fetchIntegrations } from 'thunk';
import { integrationListInvalidations } from './IntegrationListCrudInvalidations';
import { useNotification } from 'hooks/useNotification';

export const useConfigureIntegrationV2Mutation = (teamId: number) => {
  const token = useAppSelector(selectAuthToken);
  const dispatch = useAppDispatch();
  const { showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<ConfigureIntegrationV2SuccessResponse>,
    AxiosResponse<ConfigureIntegrationV2ErrorResponse>,
    ConfigureIntegrationV2Payload
  >({
    mutationFn: async (params) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return configureIntegrationV2({ params, token }) as Promise<
        AxiosResponse<ConfigureIntegrationV2SuccessResponse>
      >;
    },
    onSuccess: (response, variables) => {
      const message = response?.data?.message;

      if (
        typeof message === 'string' &&
        (message.includes('Toggle Integration V2 Modal Failed') ||
          message.includes('does not support Integration V2'))
      ) {
        // ✅ FIX: Replace alert() with toast notification
        showError(message);
        window.location.reload();
        return;
      }

      integrationListInvalidations.onUpdate({
        mosaicTeamId: teamId,
        targetServiceId: variables.targetServiceId,
      });
      dispatch(fetchIntegrations({ targetServiceId: variables.targetServiceId }));
    },
    onError: (error) => {
      // ✅ FIX: Replace alert() with toast notification
      showError(error?.data?.message || 'Failed to update integration settings');
    },
  });

  return {
    configureIntegrationV2: mutation.mutate,
    isConfiguringIntegrationV2: mutation.isPending,
  };
};
